var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("div", { staticClass: "article-image" }, [
      _vm.file.picture
        ? _c("img", {
            attrs: {
              src:
                "/api/v1/companies/1/images/" +
                _vm.file.picture.id +
                "/view?width=640",
              alt: _vm.file.title
            }
          })
        : _vm._e()
    ]),
    _c("div", { staticClass: "article-content" }, [
      _c("div", { staticClass: "article-info" }, [
        _c("h2", [_vm._v(_vm._s(_vm.file.title))]),
        _c("p", [_vm._v(_vm._s(_vm.file.description))]),
        _c(
          "div",
          { staticClass: "article-categories" },
          _vm._l(_vm.file.categories, function(category) {
            return _c("a-tag", { key: category.id }, [
              _vm._v("\n          " + _vm._s(category.name) + "\n        ")
            ])
          }),
          1
        )
      ]),
      _c("div", { staticClass: "article-buttons" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "/api/v1/companies/1/documents/files/" +
                _vm.file.id +
                "/download?token=" +
                _vm.getJwt()
            }
          },
          [
            _c("a-button", { attrs: { type: "primary" } }, [
              _vm._v("\n          Letöltés\n        ")
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }